export interface ErrorModel {
  error?: string;
  path?: string;
  status?: string;
  timestamp?: Date;
}
